import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import SidebarNew from "../components/Sidebar/SidenavNew";
import AdminNavbar from "../components/Navbar/AdminNavbar";
import IngredientCategory from "../pages/AdminDashboard/Items/IngredientCategory";
import Units from "../pages/AdminDashboard/Items/Units";
import Ingredients from "../pages/AdminDashboard/Items/Ingredients";
import AddOns from "../pages/AdminDashboard/Items/AddOns";
import AddOnForm from "../pages/AdminDashboard/Items/AddOnForm";
import MenuCategories from "../pages/AdminDashboard/Items/MenuCategories";
import MenuSubCategories from "../pages/AdminDashboard/Items/MenuSubCategories";
import Vat from "../pages/AdminDashboard/Items/Vat";
import Deals from "../pages/AdminDashboard/Items/Deals";
import Items from "../pages/AdminDashboard/Items/Items";
import AddItemCategoryForm from "../pages/AdminDashboard/Items/AddItemCategoryForm";
import AddUnitForm from "../pages/AdminDashboard/Items/AddUnitForm";
import AddIngredientForm from "../pages/AdminDashboard/Items/AddIngredientForm";
import Coupon from "../pages/AdminDashboard/Promotion/Coupon";
import Subscription from "../pages/AdminDashboard/Promotion/Subscription";
import ProductDiscount from "../pages/AdminDashboard/Promotion/ProductDiscount";
import CategoryDiscount from "../pages/AdminDashboard/Promotion/CategoryDiscount";
import Banner from "../pages/AdminDashboard/E-Commerce/Banner";
import TopBanner from "../pages/AdminDashboard/E-Commerce/TopBanner";
import OrderType from "../pages/AdminDashboard/E-Commerce/OrderType";
import SocialMedia from "../pages/AdminDashboard/E-Commerce/SocialMedia";
import Purchase from "../pages/AdminDashboard/Purchase/Purchase";
import Inventory from "../pages/AdminDashboard/Purchase/Inventory";
import InventoryAdjustment from "../pages/AdminDashboard/Purchase/InventoryAdjustment";
import ExpenseCategory from "../pages/AdminDashboard/Purchase/ExpenseCategory";
import Expenses from "../pages/AdminDashboard/Purchase/Expenses";
import SubscriptionManagement from "../pages/AdminDashboard/Management/SubscriptionManagement";
import Tables from "../pages/AdminDashboard/Management/Table";
import Return from "../pages/AdminDashboard/Management/Return";
import Deposite from "../pages/AdminDashboard/Management/Deposite";
import RiderOrder from "../pages/AdminDashboard/Delivery/RiderOrder";
import AllSales from "../pages/AdminDashboard/AllSales/AllSales";
import WebOrder from "../pages/AdminDashboard/AllSales/WebOrder";
import CustomerFeedback from "../pages/AdminDashboard/CustomerFeedback/CustomerFeedback";
import Waste from "../pages/AdminDashboard/Waste/Waste";
import Companies from "../pages/AdminDashboard/UserSection/Companies";
import AddCompanyForm from "../pages/AdminDashboard/UserSection/AddCompanyForm";
import Suppliers from "../pages/AdminDashboard/UserSection/Suppliers";
import AddSupplierForm from "../pages/AdminDashboard/UserSection/AddSupplierForm";
import Vendor from "../pages/AdminDashboard/UserSection/Vendor";
import AddVendorForm from "../pages/AdminDashboard/UserSection/AddVendorForm";
import Customer from "../pages/AdminDashboard/UserSection/Customer";
import AddCustomerForm from "../pages/AdminDashboard/UserSection/AddCustomerForm";
import SuppliersPayment from "../pages/AdminDashboard/UserSection/SuppliersPayment";
import CustomerRecieve from "../pages/AdminDashboard/UserSection/CustomerRecieve";
import Attendance from "../pages/AdminDashboard/UserSection/Attendance";
import GeneralSetting from "../pages/AdminDashboard/RoleManagemnet/GeneralSetting";
import ManageUser from "../pages/AdminDashboard/RoleManagemnet/ManageUser";
import AddMainCategoryForm from "../pages/AdminDashboard/Items/AddMainCategoryForm";
import AddSubCategoryForm from "../pages/AdminDashboard/Items/AddSubCategoryForm";
import AddBannerForm from "../pages/AdminDashboard/E-Commerce/AddBannerForm";
import AddCouponForm from "../pages/AdminDashboard/Promotion/AddCouponForm";
import AddProductDiscountForm from "../pages/AdminDashboard/Promotion/AddProductDiscountForm";
import AddCategoryDiscountForm from "../pages/AdminDashboard/Promotion/AddCategoryDiscountForm";
import AddVatForm from "../pages/AdminDashboard/Items/AddVatForm";
import UploadItemsForm from "../pages/AdminDashboard/Items/UploadItemsForm";
import UploadIngredientsForm from "../pages/AdminDashboard/Items/UploadIngredientsForm";
import AddTableForm from "../pages/AdminDashboard/Management/AddTableForm";
import AddSubForm from "../pages/AdminDashboard/Promotion/AddSubForm";
import AddWaste from "../pages/AdminDashboard/Waste/AddWaste";
import AddDealsForm from "../pages/AdminDashboard/Items/AddDealsForm";
import AddItemForm from "../pages/AdminDashboard/Items/AddItemForm";
import AddReturnForm from "../pages/AdminDashboard/Management/AddReturnForm";
import AddFeedbackForm from "../pages/AdminDashboard/CustomerFeedback/AddFeedbackForm";
import Printer from "../pages/AdminDashboard/Management/Printer";
import CleanDatabase from "../pages/AdminDashboard/Management/CleanDatabase";
import MailCongfig from "../pages/AdminDashboard/E-Commerce/MailConfig";
import Setup from "../pages/AdminDashboard/Accounting/Setup";
import UploadCustomerForm from "../pages/AdminDashboard/UserSection/UploadCustomer";
import AddSupplierPaymentForm from "../pages/AdminDashboard/UserSection/AddSupplierPaymentForm";
import DailySaleReport from "../pages/AdminDashboard/Reporting/Sales/DailySaleReport";
import SmsModuleForm from "../pages/AdminDashboard/E-Commerce/SmsModuleForm";
import PaymentGatewayForm from "../pages/AdminDashboard/E-Commerce/PaymentGatewayForm";
import QRCode from "../pages/AdminDashboard/E-Commerce/QRCode";
import WebSetting from "../pages/AdminDashboard/E-Commerce/WebSetting";
import LoyaltyPoints from "../pages/AdminDashboard/Promotion/LoyaltyPoints";
import IngredientAlert from "../pages/AdminDashboard/Purchase/IngredientAlert";
import AddInventoryAdjForm from "../pages/AdminDashboard/Purchase/AddInventoryAdjFrom";
import AddExpensesCategoryForm from "../pages/AdminDashboard/Purchase/AddExpensesCategoryForm";
import AddExpensesForm from "../pages/AdminDashboard/Purchase/AddExpensesForm";
import AddCustomerRecieveForm from "../pages/AdminDashboard/UserSection/AddCustomerRecieve";
import AddAttendanceForm from "../pages/AdminDashboard/UserSection/AddAttendanceForm";
import ChangePassword from "../pages/AdminDashboard/RoleManagemnet/ChangePassword";
import ChangeProfile from "../pages/AdminDashboard/RoleManagemnet/ChangeProfile";
import AssignItemCategoryFormm from "../pages/AdminDashboard/RoleManagemnet/AssignItemCategoryFormm";
import AddUserFormm from "../pages/AdminDashboard/RoleManagemnet/AddUsersForm";
import AddPurchasesForm from "../pages/AdminDashboard/Purchase/AddPurchasesForm";
import VatReport from "../pages/AdminDashboard/Reporting/BusinessOverview/VatReport";
import MultipleVatReport from "../pages/AdminDashboard/Reporting/BusinessOverview/MultipleVatReport";
import OverAllReport from "../pages/AdminDashboard/Reporting/BusinessOverview/OverAllReport";
import DailySummaryReport from "../pages/AdminDashboard/Reporting/BusinessOverview/DailySummaryReport";
import Setting from "../pages/AdminDashboard/Setting/Setting";
import Reporting from "../pages/AdminDashboard/Reporting/Reporting";
import Outlet from "../pages/AdminDashboard/Outlet/Outlet";
import AddOutletForm from "../pages/AdminDashboard/Outlet/AddOutlet";
import KitchenPerformanceReport from "../pages/AdminDashboard/Reporting/BusinessOverview/KitchenPerformanceReport";
import ProfitLossReport from "../pages/AdminDashboard/Reporting/BusinessOverview/ProfitLossReport";
import CustomerDueReport from "../pages/AdminDashboard/Reporting/PayablesandReceivables/CustomerDueReport";
import CustomerLedger from "../pages/AdminDashboard/Reporting/PayablesandReceivables/CustomerLedger";
import DetailedPurchaseReport from "../pages/AdminDashboard/Reporting/PayablesandReceivables/DetailedPurchaseReport";
import ExpenseReport from "../pages/AdminDashboard/Reporting/PayablesandReceivables/ExpenseReport";
import LoyaltyPointsReport from "../pages/AdminDashboard/Reporting/PayablesandReceivables/LoyaltyPointsReport";
import PurchaseReport from "../pages/AdminDashboard/Reporting/PayablesandReceivables/PurchaseReport";
import ReturnReport from "../pages/AdminDashboard/Reporting/PayablesandReceivables/ReturnReport";
import SupplierDueReport from "../pages/AdminDashboard/Reporting/PayablesandReceivables/SupplierDueReport";
import SupplierLedger from "../pages/AdminDashboard/Reporting/PayablesandReceivables/SupplierLedger";
import AttendanceReport from "../pages/AdminDashboard/Reporting/Activity/AttendanceReport";
import ConsumptionReport from "../pages/AdminDashboard/Reporting/Activity/ConsumptionReport";
import FoodSalesReport from "../pages/AdminDashboard/Reporting/Activity/FoodSalesReport";
import InventoryReport from "../pages/AdminDashboard/Reporting/Activity/InventoryReport";
import LowInventoryReport from "../pages/AdminDashboard/Reporting/Activity/LowInventoryReport";
import RegisterReport from "../pages/AdminDashboard/Reporting/Activity/RegisterReport";
import Vendorreport from "../pages/AdminDashboard/Reporting/Activity/Vendorreport";
import WasteReport from "../pages/AdminDashboard/Reporting/Activity/WasteReport";
import RiderReport from "../pages/AdminDashboard/Reporting/Activity/RiderReport";
import DetailedSaleReport from "../pages/AdminDashboard/Reporting/Sales/DetailedSaleReport";
import DetailedShiftReport from "../pages/AdminDashboard/Reporting/Sales/DetailedShiftReport";
import Feedback from "../pages/AdminDashboard/Feedback/Feedback";
import FeedbackForm from "../pages/AdminDashboard/Feedback/FeedbackForm";
import Waiter from "../pages/AdminDashboard/POSScreen/Waiter";
import BarPanel from "../pages/AdminDashboard/POSScreen/BarPanel";
import Kitchen from "../pages/AdminDashboard/POSScreen/Kitchen";
import Watchuser from "../components/Navbar/WatchUserGuide";
import ManageUserSetting from "../components/Navbar/User/ManagUserSetting";
import CopyItem from "../pages/AdminDashboard/Management/CopyItems";
import Products from "../pages/AdminDashboard/Management/Products";
import Home from "../pages/AdminDashboard/Home";
import Dashboard from "../pages/AdminDashboard/Dashboard";
import AdminFooter from "../components/AdminFooter";
import ProductCategory from "../pages/AdminDashboard/Management/ProductCategory";
import ViewItem from "../pages/AdminDashboard/RoleManagemnet/ViewItem";
import ShiftModal from "../components/AdminCards/ShiftModal";
import AssignItemModifiers from "../pages/AdminDashboard/Items/AssignItemModifiers";
import ViewModifiers from "../pages/AdminDashboard/Items/ViewModifiers";
import ViewFoodItems from "../pages/AdminDashboard/Items/ViewFoodItem";
import CreditCard from "../pages/AdminDashboard/Promotion/CreditCard";
import AddCreditCardForm from "../pages/AdminDashboard/Promotion/AddCreditCardForm";
import EditTopBannerForm from "../pages/AdminDashboard/E-Commerce/EditTopBannerForm";
import ShiftOpenForm from "../pages/AdminDashboard/ShiftOpenClose/ShiftOpenForm";
import axios from "axios";
import { apiKey } from "../config/config";
import ExpenseDetails from "../pages/AdminDashboard/Purchase/ExpenseDetails";
import Language from "../pages/AdminDashboard/Setting/Language";
import CategorySchedule from "../pages/AdminDashboard/Promotion/CategorySchedule";
import AddCategoryScheduleForm from "../pages/AdminDashboard/Promotion/AddCategoryScheduleForm";
import ReturnReceipt from "../pages/AdminDashboard/Management/ReturnReceipt";
import ChatWidget from "../components/Widgets/ChatWidget";
import { darkenHexColor } from "../config/helperFunctions";

export default function AdminLayout() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { pathname } = useLocation();
  const [showShiftModal, setShowShiftModal] = useState(false);
  const [shiftData, setShiftData] = useState();
  const [shiftError, setShiftError] = useState();
  const [logo, setLogo] = useState();
  const [general, setGeneral] = useState();
  const [currency, setCurrency] = useState();
  const [pageLoading, setPageLoading] = useState(true);

  const navigate = useNavigate();

  const toggleModal = (show) => {
    setShowShiftModal(show);
  };

  const handleLangChange = (value) => {
    localStorage.setItem("rms-lang", value);
    window.location.reload();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const user = localStorage.getItem("rms-admin");

    if (!user) {
      navigate("/admin");
    }
  });

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/shiftSummary`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setShiftData(res.data);
      })
      .catch((err) => {
        setShiftError(
          err.response.data.message || "Error while fetching shift data."
        );
      });

    axios
      .get(`${apiKey}/api/rms/admin/settings`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setLogo(
          JSON.parse(res.data.filter((set) => set.type === "logo")[0].value)
            .logo_image_url
        );
        setGeneral(
          JSON.parse(res.data.filter((set) => set.type === "general")[0].value)
        );
        setCurrency(
          JSON.parse(res.data.filter((set) => set.type === "currency")[0].value)
        );
      })
      .catch((err) => {});

    axios
      .get(`${apiKey}/api/rms/customer/settings`)
      .then((res) => {
        let colors = res.data.filter((item) => item.type === "color_theme");
        colors = JSON.parse(colors[0].value);
        console.log(colors);

        document.documentElement.style.setProperty(
          "--color-d-bg",
          colors.color_1
        );
        document.documentElement.style.setProperty(
          "--color-d-pop-btn",
          colors.color_2
        );
        document.documentElement.style.setProperty(
          "--color-d-bg-text",
          colors.color_3
        );
        document.documentElement.style.setProperty(
          "--color-d-btn-text",
          colors.color_4
        );
        document.documentElement.style.setProperty(
          "--color-d-cat-btn",
          colors.color_5
        );
        document.documentElement.style.setProperty(
          "--color-d-bg-dark",
          darkenHexColor(colors.color_5, 20)
        );
        document.documentElement.style.setProperty(
          "--color-d-bg-light",
          darkenHexColor(colors.color_5, -20)
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, user?.user.outlet_id]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <div className="bg-[#F6F7FC] flex w-full font-public_sans">
      {showShiftModal && (
        <ShiftModal
          data={shiftData}
          error={shiftError}
          logo={logo}
          general={general}
          currency={currency}
          toggle={() => setShowShiftModal(!showShiftModal)}
        />
      )}
      <div className="relative">
        <SidebarNew logo={logo} />
      </div>
      <div className="relative w-full transition-all">
        <div className="px-4 md:px-10 py-4 mx-auto w-full min-h-screen">
          <AdminNavbar
            handleLangChange={handleLangChange}
            toggleModal={toggleModal}
          />
          <ChatWidget />
          <Routes>
            <Route path="/openRegister" element={<ShiftOpenForm />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {/* Setting-Routes */}
            <Route path="/setting" element={<Setting />} />
            <Route path="/language" element={<Language />} />

            {/* Items Routes */}

            <Route
              path="/ingredientCategory"
              element={<IngredientCategory />}
            />
            <Route
              path="/ingredientCategory/addEditIngredientCategory"
              element={<AddItemCategoryForm />}
            />
            <Route
              path="/ingredientCategory/addEditIngredientCategory/:id"
              element={<AddItemCategoryForm />}
            />
            {/* <Route path="/ingredientCategory/editIngredientCategory" element={<EditIngredientCategoryForm />} /> */}
            <Route path="/units" element={<Units />} />
            <Route path="/units/addEditUnit" element={<AddUnitForm />} />
            <Route path="/units/addEditUnit/:id" element={<AddUnitForm />} />
            {/* <Route path="/units/EditUnit" element={<EditUnit />} /> */}
            <Route path="/ingredients" element={<Ingredients />} />
            <Route
              path="/ingredients/addEditIngredient"
              element={<AddIngredientForm />}
            />
            <Route
              path="/ingredients/addEditIngredient/:id"
              element={<AddIngredientForm />}
            />
            {/* <Route path="/ingredients/EditIngredient" element={<EditIngredient />} /> */}
            <Route
              path="/ingredients/uploadingredients"
              element={<UploadIngredientsForm />}
            />
            <Route path="/modifiers" element={<AddOns />} />
            <Route path="/modifiers/addModifiers" element={<AddOnForm />} />
            <Route path="/modifiers/addModifiers/:id" element={<AddOnForm />} />
            <Route
              path="/modifiers/viewModifier/:id"
              element={<ViewModifiers />}
            />
            <Route path="/foodMenuCategories" element={<MenuCategories />} />
            <Route
              path="/foodMenuCategories/addMenuCategoryForm"
              element={<AddMainCategoryForm />}
            />
            <Route
              path="/foodMenuCategories/addMenuCategoryForm/:id"
              element={<AddMainCategoryForm />}
            />
            <Route
              path="/foodMenuSubCategories"
              element={<MenuSubCategories />}
            />
            <Route
              path="/foodMenuSubCategories/addSubCategoryForm"
              element={<AddSubCategoryForm />}
            />
            <Route
              path="/foodMenuSubCategories/addSubCategoryForm/:id"
              element={<AddSubCategoryForm />}
            />
            <Route path="/VATs" element={<Vat />} />
            <Route path="/VATs/AddVat" element={<AddVatForm />} />
            <Route path="/VATs/AddVat/:id" element={<AddVatForm />} />
            <Route path="/foodMenus" element={<Items />} />
            <Route path="/foodMenus/AddItemForm" element={<AddItemForm />} />
            <Route
              path="/foodMenus/AddItemForm/:id"
              element={<AddItemForm />}
            />
            <Route
              path="/foodMenus/assignModifier/:id"
              element={<AssignItemModifiers />}
            />
            <Route
              path="/foodMenus/UploadItems"
              element={<UploadItemsForm />}
            />
            <Route
              path="/foodMenus/UploadIngredients"
              element={<UploadIngredientsForm />}
            />
            <Route
              path="/foodMenus/viewFoodMenu/:id"
              element={<ViewFoodItems />}
            />
            <Route path="/deals" element={<Deals />} />
            <Route path="/deals/addDeals" element={<AddDealsForm />} />
            <Route path="/deals/addDeals/:id" element={<AddDealsForm />} />

            {/*Management Routes */}
            <Route
              path="/subscription-managment"
              element={<SubscriptionManagement />}
            />
            <Route path="/printer" element={<Printer />} />
            <Route
              path="/printer/ProductCategory"
              element={<ProductCategory />}
            />
            <Route
              path="/printer/ProductCategory/:id"
              element={<ProductCategory />}
            />
            <Route path="/tables" element={<Tables />} />
            <Route path="/tables/addTableForm" element={<AddTableForm />} />
            <Route path="/tables/addTableForm/:id" element={<AddTableForm />} />
            {/* <Route path="/tables/editTable" element={<EditTable />} /> */}
            <Route path="/return" element={<Return />} />
            <Route
              path="/return/:id"
              element={<ReturnReceipt general={general} />}
            />
            <Route path="/return/addReturn" element={<AddReturnForm />} />
            <Route path="/deposite" element={<Deposite />} />
            <Route path="/copy-items" element={<CopyItem />} />
            <Route path="/copy-items/products" element={<Products />} />
            <Route path="/cleanDatabase" element={<CleanDatabase />} />

            {/* Delivery Routes */}
            <Route path="/listorder" element={<RiderOrder />} />

            {/* Outlet Routes */}
            <Route path="/outlet" element={<Outlet />} />
            <Route path="/outlet/addoutlet" element={<AddOutletForm />} />
            <Route path="/outlet/addoutlet/:id" element={<AddOutletForm />} />

            {/*================= Reporting Routes============== */}
            <Route path="/reporting" element={<Reporting />} />

            {/* Sale Report */}
            <Route
              path="/reporting/dailySaleReport"
              element={<DailySaleReport />}
            />
            <Route
              path="/reporting/detailedSaleReport"
              element={<DetailedSaleReport />}
            />
            <Route
              path="/reporting/detailedShiftReport"
              element={<DetailedShiftReport />}
            />

            {/* Business-Overview Report */}
            <Route path="/reporting/vatReport" element={<VatReport />} />
            <Route
              path="/reporting/multipleVatReport"
              element={<MultipleVatReport />}
            />
            <Route
              path="/reporting/overallReport"
              element={<OverAllReport />}
            />
            <Route
              path="/reporting/dailySummaryReport"
              element={<DailySummaryReport />}
            />
            <Route
              path="/reporting/kitchenPerformanceReport"
              element={<KitchenPerformanceReport />}
            />
            <Route
              path="/reporting/profileLossReport"
              element={<ProfitLossReport />}
            />

            {/*Payable & Recieveable Report  */}
            <Route
              path="/reporting/customerDueReport"
              element={<CustomerDueReport />}
            />
            <Route
              path="/reporting/customerLedger"
              element={<CustomerLedger />}
            />
            <Route
              path="/reporting/detailPurchaseReport"
              element={<DetailedPurchaseReport />}
            />
            <Route
              path="/reporting/expensesReport"
              element={<ExpenseReport />}
            />
            <Route
              path="/reporting/loyaltyPointReport"
              element={<LoyaltyPointsReport />}
            />
            <Route
              path="/reporting/purchaseReport"
              element={<PurchaseReport />}
            />
            <Route path="/reporting/returnReport" element={<ReturnReport />} />
            <Route
              path="/reporting/supplierDueReport"
              element={<SupplierDueReport />}
            />
            <Route
              path="/reporting/supplierLedgerReport"
              element={<SupplierLedger />}
            />

            {/*Activity Report  */}
            <Route
              path="/reporting/attendanceReport"
              element={<AttendanceReport />}
            />
            <Route
              path="/reporting/consumptionReport"
              element={<ConsumptionReport />}
            />
            <Route
              path="/reporting/foodSalesReport"
              element={<FoodSalesReport />}
            />
            <Route
              path="/reporting/inventoryReport"
              element={<InventoryReport />}
            />
            <Route
              path="/reporting/lowInventoryReport"
              element={<LowInventoryReport />}
            />
            <Route
              path="/reporting/registerReport"
              element={
                <RegisterReport
                  logo={logo}
                  general={general}
                  currency={currency}
                />
              }
            />
            <Route path="/reporting/vendorReport" element={<Vendorreport />} />
            <Route path="/reporting/wasteReport" element={<WasteReport />} />
            <Route path="/reporting/riderReport" element={<RiderReport />} />

            {/* All Sale Routes */}
            <Route path="/allsales" element={<AllSales />} />
            <Route path="/weborder" element={<WebOrder />} />

            {/* POS-Screen Route */}
            <Route path="/waiter" element={<Waiter />} />
            <Route path="/barPanel" element={<BarPanel />} />
            <Route path="/kitchen" element={<Kitchen />} />

            {/* E-Commerce Routes */}
            <Route path="/smsMobile" element={<SmsModuleForm />} />
            <Route path="/paymentGateway" element={<PaymentGatewayForm />} />
            <Route path="/bannersetting" element={<Banner />} />
            <Route
              path="/bannersetting/AddBannerForm"
              element={<AddBannerForm />}
            />
            <Route
              path="/bannersetting/AddBannerForm/:id"
              element={<AddBannerForm />}
            />
            <Route path="/topbanner" element={<TopBanner />} />
            <Route
              path="/topbanner/editTopbanner"
              element={<EditTopBannerForm />}
            />
            <Route path="/qrCode" element={<QRCode />} />
            <Route path="/ordertype" element={<OrderType />} />
            <Route path="/webSetting" element={<WebSetting />} />
            <Route path="/mailConfig" element={<MailCongfig />} />
            <Route path="/socialmedia" element={<SocialMedia />} />
            {/* <Route path="/socialmedia/edit_social_media" element={<EditSocialMedia />} /> */}

            {/* Accounting-Routes */}
            <Route path="/setup" element={<Setup />} />

            {/* Promotion Routes */}
            <Route path="/coupon" element={<Coupon />} />
            <Route path="/coupon/AddCouponForm" element={<AddCouponForm />} />
            <Route
              path="/coupon/AddCouponForm/:id"
              element={<AddCouponForm />}
            />
            <Route path="/creditCard" element={<CreditCard />} />
            <Route
              path="/creditCard/addEditCreditCard"
              element={<AddCreditCardForm />}
            />
            <Route
              path="/creditCard/addEditCreditCard/:id"
              element={<AddCreditCardForm />}
            />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/subscription/AddSubForm" element={<AddSubForm />} />
            <Route
              path="/subscription/AddSubForm/:id"
              element={<AddSubForm />}
            />
            <Route path="/loyalty" element={<LoyaltyPoints />} />
            <Route path="/productdiscount" element={<ProductDiscount />} />
            <Route
              path="/productdiscount/AddProductDiscountForm"
              element={<AddProductDiscountForm />}
            />
            <Route
              path="/productdiscount/AddProductDiscountForm/:id"
              element={<AddProductDiscountForm />}
            />
            <Route path="/categorydiscount" element={<CategoryDiscount />} />
            <Route
              path="/categorydiscount/AddCategoryDiscountForm"
              element={<AddCategoryDiscountForm />}
            />
            <Route
              path="/categorydiscount/AddCategoryDiscountForm/:id"
              element={<AddCategoryDiscountForm />}
            />
            <Route path="/categorySchedule" element={<CategorySchedule />} />
            <Route
              path="/categorySchedule/AddCategoryScheduleForm"
              element={<AddCategoryScheduleForm />}
            />
            <Route
              path="/categorySchedule/AddCategoryScheduleForm/:id"
              element={<AddCategoryScheduleForm />}
            />

            {/* Customer-Feedback Routes */}
            <Route path="/customer-feedback" element={<CustomerFeedback />} />
            <Route
              path="/customer-feedback/addCustomerFeedbackForm"
              element={<AddFeedbackForm />}
            />

            {/* Feedback Routes*/}
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/viewFeedback" element={<FeedbackForm />} />

            {/* Purchase Routes */}
            <Route path="/purchase" element={<Purchase />} />
            <Route
              path="/purchase/addPurchase"
              element={<AddPurchasesForm />}
            />
            <Route
              path="/purchase/addPurchase/:id"
              element={<AddPurchasesForm />}
            />
            {/* <Route path="/purchase/editPurchase" element={<EditPurchasesForm />} /> */}
            <Route path="/inventory" element={<Inventory />} />
            <Route
              path="/inventory/ingredientsAlert"
              element={<IngredientAlert />}
            />
            <Route
              path="/inventoryAdjustment"
              element={<InventoryAdjustment />}
            />
            <Route
              path="/inventoryAdjustment/addInventoryAdjForm"
              element={<AddInventoryAdjForm />}
            />
            {/* <Route path="/inventoryAdjustment/editInventoryAdj" element={<EditInventoryAdjForm />} /> */}
            <Route path="/expensescategory" element={<ExpenseCategory />} />
            <Route
              path="/expensescategory/addExpensesCategoryForm"
              element={<AddExpensesCategoryForm />}
            />
            <Route
              path="/expensescategory/addExpensesCategoryForm/:id"
              element={<AddExpensesCategoryForm />}
            />
            <Route path="/expenses" element={<Expenses />} />
            <Route
              path="/expenses/addExpenseForm"
              element={<AddExpensesForm />}
            />
            <Route
              path="/expenses/addExpenseForm/:id"
              element={<AddExpensesForm />}
            />
            <Route
              path="/expenses/expenseDetails/:id"
              element={<ExpenseDetails general={general} />}
            />

            {/* Waste Routes */}
            <Route path="/waste" element={<Waste />} />
            <Route path="/waste/addWaste" element={<AddWaste />} />

            {/* User-Section Routes */}
            <Route path="/companies" element={<Companies />} />
            <Route
              path="/companies/addCompanyForm"
              element={<AddCompanyForm />}
            />
            {/* <Route path="/companies/editCompany" element={<EditCompanyForm />} /> */}
            <Route path="/suppliers" element={<Suppliers />} />
            <Route
              path="/suppliers/addSuplierForm"
              element={<AddSupplierForm />}
            />
            <Route
              path="/suppliers/addSuplierForm/:id"
              element={<AddSupplierForm />}
            />
            {/* <Route path="/suppliers/editSuplier" element={<EditSupplierForm />} /> */}
            <Route path="/vendor" element={<Vendor />} />
            <Route path="/vendor/addVendorForm" element={<AddVendorForm />} />
            <Route path="/customer" element={<Customer />} />
            <Route
              path="/customer/addCustomerForm"
              element={<AddCustomerForm />}
            />
            <Route
              path="/customer/addCustomerForm/:id"
              element={<AddCustomerForm />}
            />
            {/* <Route path="/customer/editCustomer" element={<EditCustomerForm />} /> */}
            <Route
              path="/customer/uploadCustomer"
              element={<UploadCustomerForm />}
            />
            <Route path="/supplierPayment" element={<SuppliersPayment />} />
            <Route
              path="/supplierPayment/addSupplierPaymentForm"
              element={<AddSupplierPaymentForm />}
            />
            <Route path="/customerReceive" element={<CustomerRecieve />} />
            <Route
              path="/customerReceive/addCustomerRecieveForm"
              element={<AddCustomerRecieveForm />}
            />
            <Route path="/attendance" element={<Attendance />} />
            <Route
              path="/attendance/addAttendanceForm"
              element={<AddAttendanceForm />}
            />

            {/* Role-Management Routes */}
            <Route path="/generalSetting" element={<GeneralSetting />} />
            <Route path="/manageUser" element={<ManageUser />} />
            <Route
              path="/manageUser/addAssignItemForm"
              element={<AssignItemCategoryFormm />}
            />
            <Route
              path="/manageUser/addAssignItemForm/viewItem"
              element={<ViewItem />}
            />
            <Route path="/manageUser/addUserFormm" element={<AddUserFormm />} />
            <Route
              path="/manageUser/addUserFormm/:id"
              element={<AddUserFormm />}
            />
            {/* <Route path="/manageUser/editUser" element={<EditUserFormm />} /> */}
            <Route path="/changePassword" element={<ChangePassword />} />
            <Route path="/changeProfile" element={<ChangeProfile />} />

            {/* Watch-User-Guide Routes */}
            <Route path="/watchUser" element={<Watchuser />} />
            <Route path="/manageUserSetting" element={<ManageUserSetting />} />
          </Routes>
        </div>
        <AdminFooter />
      </div>
    </div>
  );
}
